/*
  "+ Sample" button on product cards (snippets/product-listing.liquid).

  The card already decided which sample applies, so this only adds it:
    data-variant-id     the product's own sample variant (wallpaper, commercial)
    data-sample-handle  a separate sample product (murals, via the "sample_<handle>" tag),
                        looked up from /products/<handle>.js on hover / focus so the click
                        is instant, and cached for the page

  Adds go through the theme cart API and then open the cart the same way the mural PDP's
  sample button does (snippets/mural-product-form.liquid). That ends in
  Shopify.theme.ajaxCart.updateView, which assets/cart-sample-discount.js wraps, so the
  SAMPLE_APPLY code stays in step without anything extra here.

  One delegated listener per page, so cards swapped in by the collection filters work too.
  Plain JS on purpose: jQuery is not loaded when theme scripts run.
*/
(function () {
  if (window.__wrCardSample) return;
  window.__wrCardSample = true;

  var ADDED_MS = 2500;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lookups = {};

  // The variant whose option contains "sample" (any case, same test as the cart), else the
  // product's only variant. Resolves to an available variant id, or null.
  function pickSampleVariant(product) {
    var variants = (product && product.variants) || [];
    var match = variants.filter(function (v) {
      return [v.option1, v.option2, v.option3].some(function (opt) { return /sample/i.test(opt || ''); });
    })[0];
    if (!match && variants.length === 1) match = variants[0];
    return match && match.available ? match.id : null;
  }

  function lookupHandle(handle) {
    if (!lookups[handle]) {
      lookups[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(pickSampleVariant)
        .catch(function () {
          delete lookups[handle]; // network blip: allow a retry on the next click
          return null;
        });
    }
    return lookups[handle];
  }

  function resolve(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (id) return Promise.resolve(parseInt(id, 10) || null);
    var handle = btn.getAttribute('data-sample-handle');
    return handle ? lookupHandle(handle) : Promise.resolve(null);
  }

  function getCartConfig() {
    var el = document.getElementById('cart-config');
    try { return el ? JSON.parse(el.innerHTML || '{}') : {}; } catch (e) { return {}; }
  }

  function addToCart(id) {
    var cart = window.Shopify && Shopify.theme && Shopify.theme.cart;
    if (cart && cart.addItem) return cart.addItem(id, { quantity: 1 });
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (res) {
      if (!res.ok) throw res;
      return res.json();
    });
  }

  function openCart() {
    var config = getCartConfig();
    var ajaxCart = window.Shopify && Shopify.theme && Shopify.theme.ajaxCart;
    var cart = window.Shopify && Shopify.theme && Shopify.theme.cart;
    if (!ajaxCart || !cart || config.cart_action === 'page') {
      window.location.href = config.cart_url || root + 'cart';
      return;
    }
    cart.getCart().then(function (data) {
      ajaxCart.updateView(config, data);
      if (config.cart_action === 'modal_cart') {
        ajaxCart.showModal(config);
      } else {
        ajaxCart.showDrawer(config);
      }
    });
  }

  function setState(btn, state) {
    var text = btn.querySelector('[data-card-sample-text]');
    if (!btn.hasAttribute('data-label-default') && text) {
      btn.setAttribute('data-label-default', text.textContent);
    }
    btn.classList.remove('is-adding', 'is-added', 'is-unavailable');
    btn.disabled = state === 'adding' || state === 'unavailable';
    if (state) btn.classList.add('is-' + state);
    if (text) text.textContent = btn.getAttribute('data-label-' + state) || btn.getAttribute('data-label-default') || text.textContent;
  }

  function markUnavailable(btn) {
    setState(btn, 'unavailable');
    // Say why once, then get out of the way: a dead button on the image is just noise.
    setTimeout(function () { btn.hidden = true; }, ADDED_MS);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-card-sample]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    event.stopPropagation();

    setState(btn, 'adding');
    resolve(btn).then(function (id) {
      if (!id) {
        markUnavailable(btn);
        return;
      }
      return addToCart(id).then(function () {
        setState(btn, 'added');
        openCart();
        setTimeout(function () { setState(btn, ''); }, ADDED_MS);
      });
    }).catch(function (err) {
      // The theme cart API rejects with the Response; 422 = Shopify refused the add (out of stock).
      if (err && err.status === 422) {
        markUnavailable(btn);
        return;
      }
      console.error('Card sample: failed to add to cart', err);
      setState(btn, '');
    });
  });

  // Warm the mural lookup as soon as the shopper reaches for the button.
  function prefetch(event) {
    var btn = event.target.closest && event.target.closest('[data-card-sample][data-sample-handle]');
    if (btn) lookupHandle(btn.getAttribute('data-sample-handle'));
  }
  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);
})();
